import React, { useEffect, useState, useRef } from "react";
import { CSVLink } from "react-csv";
import api from "../../services/api";
import { useNavigate } from "react-router";
import NoDataFound from "../../shared/NoDataFound";
import TableLoader from "../../shared/TableLoader";
import Paginator from "../../shared/Paginator";
import config from "../../config";
import { SlDrawer, SlIconButton } from '@shoelace-style/shoelace/dist/react';
import PreviewFrameEdit from "../PreviewFrameEdit";
import DownloadFramedPreview from "../../creativePreviews/DownloadFramedPreview";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Navigation } from "swiper";


import { roles } from "../../utils/constants";
export const lineitemCreativewiseReportsContext = React.createContext();
function CreativeWise(props) {
  const navigate = useNavigate();
  const [completeData, setCompleteData] = useState([])
  const [data, setData] = useState([]);
  const [loader, setLoader] = useState(false);
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [reportData, setReportData] = useState([])
  const [creativePreview, setCreativePreview] = useState({})
  const [tablePermissions, setTablePermissions] = useState(props.permissions);
  const csvLinkRef = useRef(); // Create a ref for CSVLink
  let csvHeaders = [
    { label: "Creative Name", key: "creative_name" },
];
if (
      localStorage.getItem("role") === roles.ops
    ) {
        csvHeaders.push({ label: "Adv Impressions", key: "adv_total_imp" });
        csvHeaders.push({ label: "Adv Clicks", key: "adv_total_click" });
        csvHeaders.push({ label: "Adv Spent", key: "adv_spent" });
        csvHeaders.push({ label: "Adv CTR(%)", key: "adv_ctr" });
        csvHeaders.push({ label: "Adv ECPM/CPD", key: "adv_ecpm" });
      
    }
    csvHeaders = csvHeaders.concat([{ label: "Impressions", key: "impressions" },
      { label: "Clicks", key: "clicks" },
      { label: "Spent", key: "total_spent" }])
    if (
      localStorage.getItem("role") === roles.ops
    ) {
        csvHeaders.push({ label: "CTR(%)", key: "ctr_percent" });
        csvHeaders.push({ label: "ECPM/CPD", key: "ecpm_cpd" });
        csvHeaders.push({ label: "Enc Impressions", key: "encrypt_imp" });
        csvHeaders.push({ label: "Adv Enc Impressions", key: "encrypt_adv_imp" });
        csvHeaders.push({ label: "Shares", key: "shares" });
    }


  const handlePageClick = (event) => {
    setCurrentPage(event.selected);
    setData(completeData.slice(event.selected * config.PER_PAGE,event.selected * config.PER_PAGE + config.PER_PAGE ))
  };

  const getdata = async (page = 0) => {
    setLoader(true);
    try {
      let res = await api({
        url: "/lineitems/lineitemResports",
        method: "POST",
        responseType: "json",
        data: {
          campaign_id: props.campaign_id,
          action: "creativewise",
          status:props.status
        },
      });
      if (res.code === 200) {
        setCompleteData(res?.data?.creativePreviews || []);
        setData(res?.data?.creativePreviews?.slice(0,config.PER_PAGE) || [])
        setTotalPages(Math.ceil(res?.data?.creativePreviews?.length / config.PER_PAGE) || 0);
        setReportData(res?.data?.totalres || [])
        setLoader(false);
      }
    } catch (error) {
      console.error(error);
      if (error.response.status === 401) navigate("/");
    }
  };
  useEffect(() => {
    getdata();
  }, []);
  const getPostViews = async(creative_id) =>{
    try {
      const post_idsResult = await api({
        url: "lineitems/getPost_idsOfBrand",
        method: "POST",
        responseType: "json",
        data: {creative_id}
      })
      const post_ids = post_idsResult.data
      const previews = await brandAdsPreview(post_ids)
    } catch (error) {
      console.error("Error @ getPostViews", error)
    }
  }
  const brandAdsPreview = async(post_ids)=>{
    try {
      const res = await api({
        url : "lineitems/post_idsPreview",
        method: "POST",
        responseType: 'json',
        data: {post_ids}
      })
      setCreativePreview(res.data)
    } catch (error) {
      console.error('Error @ brandAdsPreview', error)
    }
  }
  return (
    <>
      <div className="overflow-x-auto mb-4">
      <div className="d-flex justify-end  pr-4">
      <CSVLink
          data={completeData?.map(
              (citem) => {
                let item = reportData.find(ditem => +ditem._id === +citem.creative_id || +ditem._id === +citem.dfp_creative_id)
                  let obj = {
                      creative_name: citem.name,
                      impressions: item?.total_imp,
                      clicks: item?.total_click,
                      total_spent: item?.total_spent
                  };
                  if (
                    localStorage.getItem("role") === roles.ops
                  ) {
                      obj.shares = item?.shares;
                      obj.ctr_percent =  item ? item?.total_click > 0 && item?.total_imp > 0
                        ? (
                            (item?.total_click / item?.total_imp) *
                            100
                          ).toFixed(2)
                        : 0 : 0;
                      obj.ecpm_cpd = item ? ((item?.total_spent / item?.total_imp) * 1000).toFixed(2) : 0;
                      obj.adv_ctr =  item ? item?.adv_total_click > 0 && item?.adv_total_imp > 0
                        ? (
                            (item?.adv_total_click / item?.adv_total_imp) *
                            100
                          ).toFixed(2)
                        : 0 : 0;
                      obj.adv_ecpm = item ? ((item?.adv_spent / item?.adv_total_imp) * 1000).toFixed(2) : 0;
                      obj.adv_total_imp = item?.adv_total_imp
                      obj.adv_total_click = item?.adv_total_click
                      obj.adv_spent = item?.adv_spent
                      obj.encrypt_imp = item ? parseInt(
                        item?.encrypt_imp > 0 ? item?.encrypt_imp : 0
                      ) : 0
                      obj.encrypt_adv_imp = item ? parseInt(
                        item?.encrypt_adv_imp > 0 ? item?.encrypt_adv_imp : 0
                      ) : 0
                      obj.shares = item ? parseInt(item?.shares > 0 ? item?.shares : 0) : 0
                  }
                  return obj;
              }
          ) || []}
          headers={csvHeaders}
          filename={`${props.campaign_name}_Creative_wise.csv`}
          ref={csvLinkRef} // Assign the ref to the CSVLink component
      ></CSVLink>
      <SlIconButton
          library="lucide"
          name="download"
          onClick={() => {
            csvLinkRef?.current?.link?.click();
          }}
      ></SlIconButton>
      </div>
        <table className="table table-bordered">
          <thead>
            <tr>
              {/* Campaign Creation */}
              {/* <th scope="col">Campaign Id</th> */}
              <th scope="col">Creative Name</th>
              {localStorage.getItem("role") === roles.ops && (
                  <th scope="col">Adv Impressions</th>
                )}
              {localStorage.getItem("role") === roles.ops && (
                  <th scope="col">Adv Clicks</th>
                )}
              {localStorage.getItem("role") === roles.ops && (
                  <th scope="col">Adv CTR(%)</th>
                )}
              {localStorage.getItem("role") === roles.ops && (
                  <th scope="col">Adv ECPM</th>
                )}
              <th>Impressions</th>
              <th>Clicks</th>
              {localStorage.getItem("role") === roles.ops && (
                  <th scope="col">CTR(%)</th>
                )}
              {localStorage.getItem("role") === roles.ops && (
                  <th scope="col">ECPM</th>
                )}
              {localStorage.getItem("role") === roles.ops && (
                  <th scope="col">Advertiser Spent</th>
                )}
              <th scope="col">Spent</th>
              {localStorage.getItem("role") === roles.ops && <th>Shares</th>}
              <th></th>
            </tr>
          </thead>
          {data?.length && !loader ? (
            <tbody>
              {data?.map((citem, index) => {
                let item = reportData.find(ditem => +ditem._id === +citem.creative_id || +ditem._id === +citem.dfp_creative_id)
                return (
                  <tr key={index}>
                    <td onClick={() => {props.setCreativeDetails({creative_id: citem.dfp_creative_id ? citem.dfp_creative_id : citem.creative_id, creative_name: citem.name})}} style={{color: "blue", cursor: "pointer"}}>{citem.name}</td>
                    {localStorage.getItem("role") === roles.ops && (
                        <td>{item ? parseInt(item?.adv_total_imp) : 0}</td>
                      )}
                    {localStorage.getItem("role") === roles.ops && (
                        <td>{item ? parseInt(item?.adv_total_click) : 0}</td>
                      )}
                    {localStorage.getItem("role") === roles.ops && (
                      <td>
                        {item && item.adv_total_click > 0 && item.adv_total_imp > 0
                          ? (
                              (item.adv_total_click / item.adv_total_imp) *
                              100
                            ).toFixed(2)
                          : 0}
                      </td>
                    )}
                    {localStorage.getItem("role") === roles.ops && (
                      <td>
                        {item ? ((item?.adv_spent / item?.adv_total_imp) * 1000).toFixed(2) : 0}
                      </td>
                    )}
                    <td> {item ? item?.total_imp : 0}</td>

                    <td>{item ? parseInt(item?.total_click) : 0}</td>

                    
                    {localStorage.getItem("role") === roles.ops && (
                        <td>
                          {item ? item?.total_click > 0 && item?.total_imp > 0
                            ? (
                                (item?.total_click / item?.total_imp) *
                                100
                              ).toFixed(2)
                            : 0 : 0}
                        </td>
                      )}
                    {localStorage.getItem("role") === roles.ops && (
                        <td>
                          {item && item?.total_spent && item?.total_imp ? ((item?.total_spent / item?.total_imp) * 1000).toFixed(2) : 0}
                        </td>
                      )}

                    {localStorage.getItem("role") === roles.ops && (
                        <td>
                          {item ? (item?.adv_spent).toFixed(2) : 0}
                        </td>
                      )}

                    <td>{item ?  (item?.total_spent).toFixed(2)  : 0}</td>

                    {localStorage.getItem("role") === roles.ops && (
                      <td className="p-2">
                        {item ? parseInt(item?.shares > 0 ? item?.shares : 0) : 0}
                      </td>
                    )}
                    <td>
                    <div className="d-flex gap-3" style={{ fontSize: "20px" }}>
                          <sl-icon-button
                            library="lucide"
                            name="view"
                            onClick={() => { if(citem.creative_type !== "brandAd")setCreativePreview(citem); else getPostViews(citem.creative_id) }}></sl-icon-button>
                        </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          ) : !data?.length && !loader ? (
            <NoDataFound colspan="15" />
          ) : (
            <TableLoader colspan="15" />
          )}
        </table>
      </div>
      <div>
        {totalPages > 1 && (
          <Paginator
            pageCount={totalPages}
            handlePageClick={handlePageClick}
            forcePage={currentPage}
          />
        )}
      </div>

    {Object.keys(creativePreview).length > 0 ? <SlDrawer open={Object.keys(creativePreview).length > 0} onSlAfterHide={() => setCreativePreview({})} style={{ '--size': '30vw' }}>
    <section className="basis-5/12 rounded-2xl overflow-hidden">
        {<> {(Object.keys(creativePreview).length > 0 ?
            <lineitemCreativewiseReportsContext.Provider value={{ campPreview: creativePreview }}><DownloadFramedPreview preview={creativePreview} /><PreviewFrameEdit showPreview={true} /></lineitemCreativewiseReportsContext.Provider> : null)} </>}
    </section>
      </SlDrawer> : null}
    </>
  );
}

export default CreativeWise;
